import { render } from "./OperationsAllocations.vue?vue&type=template&id=0f9647f9"
import script from "./OperationsAllocations.vue?vue&type=script&lang=js"
export * from "./OperationsAllocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__